import React, { useContext } from "react";
import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../utils";

const StakingModal = ({
  stakingOpenModal,
  stakingHandleClose,
  stakeHandler,
  amount,
  setAmount,
  nuladress,
  refferer,
}) => {
  const { t } = useTranslation();
  const { account, connect } = useContext(AppContext);

  return (
    <Box>
      <Modal open={stakingOpenModal} onClose={stakingHandleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "#000",
            padding: { md: "2rem 4rem ", xs: "2rem 1rem " },
            height: "auto",
            boxShadow: "0px 0px 8px 1px",
            border: "1px solid black",
            borderRadius: "20px",
            minWidth: { xs: "320px", sm: "400px" },
          }}
        >
          <Box>
            <Typography
              sx={{
                textAlign: "center",
                fontFamily: "Poppins",
                fontSize: { md: "16px", xs: "12px" },
                fontWeight: "400",
                color: "#fff",
                visibility: "hidden",
              }}
            >
              {t("Staking.des")}
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: { sm: "space-between", xs: "center" },
                alignItems: "center",
                flexDirection: { sm: "row", xs: "column" },
                gap: 2,
              }}
              // eslint-disable-next-line eqeqeq
              display={refferer == nuladress || nuladress ? "flex" : "none"}
            >
              <Typography
                varaint="h3"
                sx={{
                  fontSize: { md: "20px", sm: "13px", xs: "15px" },
                  fontWeight: "400",
                  fontFamily: "Poppins",
                  color: "#ffffff",
                  textAlign: "left !important",
                }}
              >
                {/* Refferrer Address   */} {t("StakingUi.phead7")}
              </Typography>

              <TextField
                value={refferer}
                placeholder="0x00....."
                type="text"
                InputLabelProps={{
                  style: { color: "#fff" },
                }}
                sx={{ width: { sm: "50%", xs: "100%" } }}
                InputProps={{
                  sx: {
                    background: "transparent",
                    boxShadow: "0px 0px 5px 1px",
                    color: "#ffffff",

                    "&.MuiOutlinedInput-root": {
                      "& fieldset": {
                        border: "none",
                      },
                      "&:hover fieldset": {
                        border: "none",
                      },
                      "&.Mui-focused fieldset": {
                        border: "none",
                        outline: "none",
                      },
                    },
                  },
                }}
              />
            </Box>

            <Box
              mt={5}
              sx={{
                display: "flex",
                justifyContent: { sm: "space-between", xs: "center" },
                alignItems: "center",
                flexDirection: { sm: "row", xs: "column" },
                gap: 2,
              }}
            >
              <Typography
                varaint="h3"
                sx={{
                  fontSize: { md: "20px", sm: "13px", xs: "15px" },
                  fontWeight: "400",
                  fontFamily: "Poppins",
                  color: "#ffffff",
                  textAlign: "left !important",
                }}
              >
                {/* Amount  */} {t("StakingUi.phead8")}
              </Typography>
              <TextField
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                placeholder="Enter computing power"
                type="number"
                InputLabelProps={{
                  style: { color: "#fff" },
                }}
                sx={{ width: { sm: "50%", xs: "100%" } }}
                InputProps={{
                  sx: {
                    background: "transparent",
                    boxShadow: "0px 0px 5px 1px",
                    color: "#ffffff",
                    "&.MuiOutlinedInput-root": {
                      "& fieldset": {
                        border: "none",
                      },
                      "&:hover fieldset": {
                        border: "none",
                      },
                      "&.Mui-focused fieldset": {
                        border: "none",
                        outline: "none",
                      },
                    },
                  },
                }}
              />
            </Box>

            <Box display="flex" justifyContent="center" mt={5}>
              {account ? (
                <Button
                  sx={{
                    color: "white",
                    backgroundColor: "#CB3C35",
                    border: "2px solid gray",
                    borderRadius: "10px",
                    padding: "0.5rem 1rem",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#CB3C35",
                    },
                  }}
                  //   disabled={stakeDetails.length > 0 ? true : false}
                  onClick={() => stakeHandler()}
                >
                  {/* Stake  */} {t("StakingUi.phead9")}
                </Button>
              ) : (
                <Button
                  sx={{
                    color: "white",
                    backgroundColor: "#CB3C35",
                    border: "2px solid gray",
                    borderRadius: "10px",
                    padding: "0.5rem 1rem",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#CB3C35",
                    },
                  }}
                  onClick={() => connect()}
                >
                  {t("StakingUi.phead10")}
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default StakingModal;
